import { gql } from "@/services/httpAdapter";

export const VehicleFragment = gql`
	fragment Vehicle on VehicleDetails {
		_id
		make
		model
		stockNumber
		trim
		colorExterior
		type
		vinNumber
		year
		transferAmount
	}
`;

export const RequestStatusFragment = gql`
	fragment RequestStatus on RequestStatus {
		_id
		approvedBy
		approvedDate
		resolvedBy
		createdBy
		createdDate
		rejectReason
		requestedBy
		requestedDate
		status
		statusDate
	}
`;

export const VehicleInventoryFragment = gql`
	fragment Vehicle on Vehicle {
		_id
		locationId
		dmsId
		gpsId
		gpsProtected
		gpsInconsistency
		kmsId
		systemStatus
		statusInHistory
		properties {
			dataType
			displayName
			precision
			value
			width
		}
		keyStates {
			_id
			isConsistent
			lastEvent
		}
		kmsLastEventsByKiosk {
			kioskId
			eventType
			penaltyUserName
		}
	}
`;
